<main class="main vh-100">
  <section class="auth-login h-100">
    <div class="container-fluid h-100 px-0">
      <div class="row h-100 mx-0">
        <div class="col-md-6 pl-md-0 d-none d-md-block">
          <div class="auth-login-car h-100">
            <div class="auth-login-carAnimation">
              <img
                src="{{ env }}assets/img/car.png"
                class="auth-login-carImg"
                alt=""
              />
            </div>
          </div>
        </div>

        <div class="col-md-6 px-0 pl-md-3 pr-md-0">
          <div class="auth-form-module">
            <form
              method="POST"
              class="auth-login-form credential"
              [formGroup]="forgotPasswordForm"
              (submit)="submit()"
            >
              <div class="auth-login-formHeader text-right mb-5">
                <a href="javascript:void(0)" class="auction-logo ml-auto">
                  <img
                    src="{{ env }}assets/img/auction_logo2.svg"
                    alt="Altawkilat-Auction"
                    class="auction-logo-img"
                  />
                </a>
              </div>

              <div class="reset-info mb-4">
                <p class="color-ashen m-0">
                  Enter the email address associated with your account and we
                  will send you the link to reset your password
                </p>
              </div>

              <div class="form-group">
                <input
                  id="email"
                  type="email"
                  name="email"
                  class="form-control credential__input transparent"
                  placeholder="email"
                />
              </div>

              <div class="auth-form-btnGrp mb-4">
                <button type="submit" class="btn btn__main fs-normal w-100">
                  Continue
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </section>
</main>
